import { render, staticRenderFns } from "./UserPermissionRow.vue?vue&type=template&id=8108bcb0&scoped=true"
import script from "./UserPermissionRow.vue?vue&type=script&lang=js"
export * from "./UserPermissionRow.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionRow.vue?vue&type=style&index=0&id=8108bcb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8108bcb0",
  null
  
)

export default component.exports